<template>
  <aw-drag
    v-if="edit || element.children?.length || publicUpload"
    :enable="edit && data.sort === 'rank'"
    :drag-item="element"
    #default="{ dragHandle }"
    class="DocumentBlock -table bg-white"
    :class="{ DocumentHasPlaceholder: element.placeholder, isCommentOpened: isCommentOpened, DocumentHighlightSearch: $route.hash === '#el' + element.id }"
    :id="'el' + element.id"
  >
    <div class="DocumentElement -table" ref="dropAreaEl">
      <div
        class="w-full bg-bc-blue flex flex-row justify-center space-x-2 p-4"
        v-if="element.locked && !isEveryElementLocked && !isPageLocked"
      >
        <aw-icon icon="lock" class="w-5 h-5 text-white " />
        <span class="text-white text-sm">{{$t('Element is locked')}}</span>
      </div>
      <!-- <div class="TableResponsiveWrapper"> -->
      <document-upload-drop-zone
        :upload-enabled="draggedElement === null && !dragged"
        :visible="edit || publicUpload"
        :public-upload="publicUpload"
        v-model="element"
        v-model:modelChildren="children"
      >
        <aw-drop
          tag="table"
          :list="childrenSorted"
          :can-drop-item="canDropItem"
          :create-placeholder="createPlaceholder"
          transition-name="document-elements"
          list-item-key="key"
          @drop-item="dropFiles"
          :drop-area-el="$refs.dropAreaEl"
          class="Table Table--Stripped"
          #default="{ item, index }"
        >
          <document-element-files-file
            :element="item"
            :parent="element"
            :page="page"
            :key="item.key"
            :class="{ DocumentElementDragged: item.dragged }"
            :index="index"
            :eye-selected="selectedPreviewFileId === item.file?.id"
            @on-open-image="openGallery(element.id, item.file ? item.file : item.file_upload)"
            @on-preview-image-id="setImagePreviewId"
            @on-blur-name-input="focused = null"
            @on-focus-name-input="focused = 'sort'"
          />
        </aw-drop>

        <!-- <div
          v-if="data.canva && edit"
          class="
            flex
            justify-center
            items-center
            px-6
            py-2
            border-1 border-gray-400
            hover:border-bc-blue
            border-dashed
            rounded-md
            cursor-pointer
            bg-bc-gray-bg
            hover:text-bc-blue
            text-gray-400
          "
        >
          <div class="space-x-1 text-center" @click="canva">
            <aw-icon icon="canva" class="inline-block h-6 w-6 " />
            <span class="relative cursor-pointer rounded-md">
              {{$t('Add Canva design')}}
            </span>
          </div>
        </div> -->
      </document-upload-drop-zone>

      <!-- </div> -->

      <div class="DocumentBlock__PanelLeft -table inline-flex items-center">
        <document-files-actions v-model="element" />
      </div>

      <!-- comments -->
      <document-comment
        v-if="bcDocumentStore.document.allow_comments"
        v-model="element.comments"
        :element="element"
        :document="bcDocumentStore.document"
        @comment-toggle="resolveZindexOnParent"
      />

      <!-- panel s moznosti noveho elementu -->
      <document-hot-action
        :parent="parent"
        :page="page"
        :index="index + 1"
        v-if="edit && !isLastOnPage"
      />
    </div>
    <div class="DocumentBlock__PanelRight -table">
      <span
        ref="DocumentCircle"
        class="DocumentCircle mr-2.5 sm:mr-3.5"
        :class="{
          'DocumentCircle--active':
            bcSelectedStore.selected.has(element.id) &&
            bcSelectedStore.selected.get(element.id)[3],
          'DocumentCircle--child-active':
            bcSelectedStore.selected.has(element.id) &&
            !bcSelectedStore.selected.get(element.id)[3]
        }"
        :data-item-index="element.root_rank"
        @click.prevent.stop="bcSelectedStore.select(
          element, 
          {
            isRecursive: true,
            isShift: $event.shiftKey,
            isDocument: true,
            itemIndex: element.root_rank,
          }
        )"
      ></span>
      <span
        class="cursor-move text-gray-400 hover:text-gray-500"
        v-if="edit"
        :ref="dragHandle"
      >
        <aw-icon icon="dots" class="w-4 h-4 -mx-1 "></aw-icon>
        <aw-icon icon="dots" class="w-4 h-4 -mx-1 "></aw-icon>
      </span>
    </div>
  </aw-drag>
</template>

<script>
import FilesElement from '../../mixins/FilesElement'
// import Canva from '../../mixins/Canva'
import Selected from '../../mixins/Selected'

export default {
  emits: ['update:modelImagePreview'],
  props: {
    currentImageIndex: Number,
    modelImagePreview: [Number, null]
  },
  mixins: [
    FilesElement, 
    Selected,
    // Canva
  ],
  allowedChildElements: ['file'],
  data() {
    return {
      dropAreaEl: undefined,
    }
  },
  computed: {
    currentImage() {
      if (this.modelImagePreview) {
        return this.modelImagePreview
      }
      return {}
    },
    selectedPreviewFileId: {
      get() {
        return this.modelImagePreview
      },
      set(newId) {
        this.$emit('update:modelImagePreview', newId)
      }
    },
  },
  methods: {
    setImagePreviewId(id) {
      this.selectedPreviewFileId = id
    },
  },
  mounted() {
    this.assignItemToSelectBtn('DocumentCircle', this.element)
  },
}
</script>

<style lang="scss" scoped></style>
